import { motion } from "framer-motion";
import { FileArrowDown, BookOpen } from "@phosphor-icons/react";
import { RESOURCES } from "@/constants/testIds";

const resources = [
  {
    testIdCard: RESOURCES.manifestoCard,
    testIdBtn: RESOURCES.manifestoDownload,
    icon: BookOpen,
    title: "The Process Drag Manifesto",
    description: "A foundational document arguing that HR transformation fails because organizations choose technology first. Learn about Process Physics and how to measure before you transform.",
    url: "https://customer-assets.emergentagent.com/job_siveli-stp-builder/artifacts/hiia65jd_manifesto.pdf",
    tag: "Strategic Framework",
  },
  {
    testIdCard: RESOURCES.diagnosticCard,
    testIdBtn: RESOURCES.diagnosticDownload,
    icon: FileArrowDown,
    title: "HR Operations Self-Diagnostic",
    description: "Twelve questions across four pillars to surface where Process Drag is hiding. A practical scorecard for HR Directors, VPs, and CHROs to quantify function health in ten minutes.",
    url: "https://customer-assets.emergentagent.com/job_siveli-stp-builder/artifacts/lky4f8qm_self-diagnostic.pdf",
    tag: "Diagnostic Tool",
  },
];

export default function Resources() {
  return (
    <section
      id="resources"
      data-testid={RESOURCES.section}
      className="relative py-24 sm:py-32 lg:py-40"
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-8 md:px-12">
        <motion.p
          data-testid={RESOURCES.overline}
          className="overline mb-4"
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
        >
          Resources
        </motion.p>
        <motion.h2
          data-testid={RESOURCES.heading}
          className="text-4xl sm:text-5xl font-bold tracking-tight mb-6 max-w-2xl text-themed-primary"
          style={{ fontFamily: "var(--sv-heading-font)" }}
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          Start With Evidence
        </motion.h2>
        <p className="text-themed-body text-base sm:text-lg max-w-xl mb-16 leading-relaxed">
          Download our proprietary frameworks and self-assessment tools. No forms, no gatekeeping.
        </p>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {resources.map((res, i) => (
            <motion.div
              key={res.title}
              data-testid={res.testIdCard}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: i * 0.15 }}
              className="glass-card p-8 sm:p-10 flex flex-col justify-between"
            >
              <div>
                <div className="flex items-center gap-3 mb-6">
                  <res.icon size={32} weight="duotone" className="text-themed-gold" />
                  <span className="text-xs text-themed-gold tracking-widest uppercase" style={{ fontFamily: "var(--sv-mono-font)" }}>{res.tag}</span>
                </div>
                <h3 className="text-xl sm:text-2xl font-semibold text-themed-primary mb-4" style={{ fontFamily: "var(--sv-heading-font)" }}>{res.title}</h3>
                <p className="text-themed-body text-sm sm:text-base leading-relaxed mb-8">{res.description}</p>
              </div>
              <a
                data-testid={res.testIdBtn}
                href={res.url}
                target="_blank"
                rel="noopener noreferrer"
                className="btn-shine inline-flex items-center gap-2 px-6 py-3 text-sm font-medium text-themed-primary transition-colors w-fit"
                style={{ border: "1px solid var(--sv-border)" }}
              >
                <FileArrowDown size={18} weight="bold" />
                Download PDF
              </a>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
